import { createSlice } from '@reduxjs/toolkit'
import UsersService from './users.service'
import { USERS } from '../../utils/constants/actionTypes'
import createAsyncThunkMiddleware from '../../utils/helpers/createAsyncThunkMiddleware'
import extraReducersCommon from '../common/extraReducers'

/**
 * body - {...}
 */
export const createUser = createAsyncThunkMiddleware(
  USERS.CREATE,
  UsersService.create,
)

/**
 * filter, limit, page
 */
export const getAllUsers = createAsyncThunkMiddleware(
  USERS.GET_ALL,
  UsersService.getAll,
)

/**
 * { userId, body - {...}}
 */
export const updateUser = createAsyncThunkMiddleware(
  USERS.UPDATE,
  UsersService.update,
)

/**
 * userId
 */
export const removeUser = createAsyncThunkMiddleware(
  USERS.REMOVE,
  UsersService.remove,
)

const initialState = {}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: extraReducersCommon(
    createUser,
    updateUser,
    getAllUsers,
    removeUser,
  ),
})

export default usersSlice.reducer
